import bandImage1 from './band1.png';
import bandImage2 from './band2.png';
import bandImage3 from './band3.png';
import bandImage4 from './band4.png';

export const bandPhoto1 = () => bandImage1;
export const bandPhoto2 = () => bandImage2;
export const bandPhoto3 = () => bandImage3;
export const bandPhoto4 = () => bandImage4;
